import React from "react";
import { Box } from "@mui/material";

// `editing`: Image Edit's plain "Editing" label, no pill chrome so it fits
// beside a longer nav label.
type Props = { label: string; variant?: "editing" };
/**
 * Amber "Building" pill shown on the Concepts nav item while any concept is
 * processing (#3544 mockup). `label` carries the accessible description,
 * e.g. "2 concepts processing".
 */
export const BuildingChip = ({ label, variant }: Props) => (
  <Box
    aria-label={label}
    title={label}
    sx={{
      ml: "auto",
      flexShrink: 0,
      display: "inline-flex",
      alignItems: "center",
      gap: 0.75,
      px: 1.1,
      py: 0.25,
      borderRadius: 999,
      fontSize: "0.65rem",
      fontWeight: 700,
      color: "#9a6b1a",
      backgroundColor: "#fdf3e3",
      border: "1px solid #ecd9b8",
      ...(variant === "editing" && {
        px: 0,
        border: 0,
        backgroundColor: "transparent",
      }),
    }}
  >
    <Box
      sx={{
        width: 6,
        height: 6,
        borderRadius: 999,
        backgroundColor: "#c98a3a",
        animation: "buildingPulse 1.2s ease-in-out infinite",
        "@keyframes buildingPulse": {
          "0%, 100%": { opacity: 1 },
          "50%": { opacity: 0.35 },
        },
      }}
    />
    {variant === "editing" ? "Editing" : "Building"}
  </Box>
);
